import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=5141c3f6&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"
import style0 from "./OrderComplete.vue?vue&type=style&index=0&id=5141c3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141c3f6",
  null
  
)

export default component.exports